'use client'

import { useSession } from '@marketplace-web/shared/session'
import { CurrencyAmountModel } from '@marketplace-web/domain/currency-data'
import { useAbTest } from '@marketplace-web/shared/ab-tests'

import ServiceFeeIncludedTitle from '../ServiceFeeIncludedTitle'

type Props = {
  thumbnailUrl?: string | null
  itemTitle: string
  transactionId: number
  itemsCount: number
  itemId: number
  serviceFee: CurrencyAmountModel
  totalAmountWithoutTax: CurrencyAmountModel
  itemPrice: CurrencyAmountModel
  sellerId?: number
  isSellerBusiness: boolean
}

const HeroMessagePriceBreakdown = ({
  thumbnailUrl,
  itemTitle,
  transactionId,
  itemsCount,
  itemId,
  totalAmountWithoutTax,
  serviceFee,
  itemPrice,
  sellerId,
  isSellerBusiness,
}: Props) => {
  const currentUserId = useSession().user?.id
  const unifiedPriceBreakdownIsAbTestIsOn = useAbTest('unified_price_breakdown')?.variant === 'on'

  const isBundle = itemsCount > 1
  const isDetailedBreakdownVisible = itemsCount === 1 || unifiedPriceBreakdownIsAbTestIsOn
  const isViewingOwnItem = sellerId === currentUserId

  const detailedBreakdownProps = isDetailedBreakdownVisible
    ? {
        itemPhotoSrc: thumbnailUrl,
        itemTitle,
        transactionId,
        itemsCount,
      }
    : null

  return (
    <ServiceFeeIncludedTitle
      itemId={itemId}
      itemPrice={itemPrice}
      serviceFee={serviceFee}
      isSellerBusiness={isSellerBusiness}
      isItemOwner={isViewingOwnItem}
      detailedBreakdown={detailedBreakdownProps}
      totalItemPrice={totalAmountWithoutTax}
      trackUnification={isBundle}
    />
  )
}

export default HeroMessagePriceBreakdown
